import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import type { CampaignLeftOutReason } from '../../constants/campaign-builder';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { CampaignEntity } from './campaign.entity';

/**
 * PD-17616 — a person Workd left out of a campaign when people were added,
 * and why ("Review who was left out"). One row per person per campaign; a
 * later add that leaves them out again updates the reason, and "Add anyway"
 * or a later add that takes them removes the row.
 *
 * A separate table rather than a membership state: memberships are read by
 * the engine, the Contacts list's Campaign filter, Mission Control's mirror
 * and the Instantly rotation, and none of them should ever see a person who
 * was never in the campaign. Not auditable: it is a computed list.
 */
@Index('campaign_left_out__campaign_contact', ['fkCampaignId', 'fkContactId'], { unique: true })
@Entity('campaign_left_out', {}, { auditable: false })
export class CampaignLeftOutEntity extends BaseEntity {
	@Column('int', { name: 'fk_campaign__id', unsigned: true })
	public fkCampaignId!: number;

	@Column('int', { name: 'fk_contact__id', unsigned: true })
	public fkContactId!: number;

	/** The account they were found at, when there was one. */
	@Column('int', { name: 'fk_client__id', unsigned: true, nullable: true })
	public fkClientId!: number | null;

	// App-validated (CampaignLeftOutReason).
	@Column('varchar', { name: 'reason', length: 30 })
	public reason!: CampaignLeftOutReason | string;

	@Column('varchar', { name: 'email', length: 255, nullable: true })
	public email!: string | null;

	@ManyToOne(() => CampaignEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_campaign__id', referencedColumnName: 'id' }])
	public fkCampaign!: CampaignEntity;
}
